import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import classnames from 'classnames';

import Header from '../../../controls/header/Header.jsx';
import Image from '../../../controls/image/Image.jsx';
import CostTypeSelector from '../../../controls/costTypeSelector/CostTypeSelector.jsx';
import ProgressBar from '../../../controls/progressBar/ProgressBar.jsx';

import {
    ICON_SETTING,
    ICON_ARROW_GRAY
} from 'pluton-core/lib/constants/image.constant';
import { routes } from 'pluton-core/lib/constants/routes.constant';
import { history } from '../../../../entry/history';
import { DATEPICKER_FORMAT } from 'pluton-core/lib/constants/data.constant'
import { isEmpty } from 'pluton-core/lib/utils/helpers'
import {
    getMaxDate,
    isAllowNextPeriod,
    getCostModeLabel
} from 'pluton-core/lib/services/core/cost/cost.helper';
import {
    getControlChartValueAndLabel,
    isNotActiveDeviceStatus
} from 'pluton-core/lib/services/core/control/control.helper';

import { composeCostChartComponent } from 'pluton-charts/lib/charts/cost/CostChartComponent';
import {
    // VictoryAxis,
    VictoryChart,
    VictoryGroup,
    VictoryArea,
    VictoryZoomContainer,
    VictoryLabel,
} from "victory";
import { VictoryAxis } from '../../../charts/victory/cost/VictoryAxis';

const CostChartComponent = composeCostChartComponent({
    VictoryAxis,
    VictoryChart,
    VictoryGroup,
    VictoryArea,
    VictoryZoomContainer,
    VictoryLabel,
});

let timerResetRotate;

class DevicePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            canResetRotate: true
        };
    }

    componentWillUnmount() {
        clearTimeout(timerResetRotate);
        timerResetRotate = null;
    }

    handleOnBack = () => {
        history.goBack();
    };

    handleSetDeviceStatus = () => {
        if (!this.state.canResetRotate || this.props.deviceData.changeStatus && this.props.deviceData.changeStatus.isLoading) {
            return;
        }

        this.setState((prevState, props)=> {
            return {
                canResetRotate: false
            }
        }, ()=> {
            clearTimeout(timerResetRotate);
            timerResetRotate = setTimeout(()=> {
                this.setState((prevState, props)=> {
                    return {
                        canResetRotate: true
                    }
                });
            }, 2000)
        });
        this.props.handleSetDeviceStatus();
    };

    handleDatePickerChanged = (e) => {
        this.props.handleDateChange(e);
    };

    handleChartType = (e) => {
        this.props.handleChartType(e.target.value);
    };

    handleGetPrev = (e) => {
        this.props.handleGetPrev();
    };

    handleGetNext = (e) => {
        this.props.handleGetNext();
    };

    renderHeader = () => {
        return (
            <Header headerTitle={this.props.deviceData.data.name}>
                <Link className="header__link header__link--left"
                      onClick={this.handleOnBack}>
                    <Image
                        src={ICON_ARROW_GRAY}
                        className="header__icon header__icon--left"
                        imgClassName="icon icon--header"
                    />
                </Link>
                <Link className="header__link header__link--right"
                      to={`${routes.settings()}`}>
                    <Image
                        src={ ICON_SETTING }
                        className="header__icon header__icon--right"
                        imgClassName="icon icon--header"
                    />
                </Link>
            </Header>
        );
    };

    renderChartFilter = () => {
        const isAllowNext = isAllowNextPeriod(this.props.date);
        return (
            <div className="chart-nav">
                <div className="chart-nav__prev" onClick={this.handleGetPrev}>
                    prev
                </div>
                <div className="chart-nav__select">
                    <CostTypeSelector
                        value={this.props.costState.type}
                        onChange={this.handleChartType}
                    />
                </div>
                {
                    isAllowNext &&
                    <div className="chart-nav__next" onClick={this.handleGetNext}>
                        next
                    </div>
                }
            </div>
        );
    };

    renderChart = () => {
        return (
            <div className="chart chart--appliance">
                <CostChartComponent data={this.props.deviceData.chart}/>
            </div>
        );
    };

    renderBodyHeader = () => {
        return (
            <div className="page__top">
                <div className="datepicker">
                    <DatePicker
                        ref="datepicker"
                        readOnly={true}
                        autoFocus={false}
                        dateFormat={DATEPICKER_FORMAT}
                        selected={moment(this.props.date)}
                        onChange={this.handleDatePickerChanged}
                        className='datepicker__field'
                        maxDate={getMaxDate()}
                    />
                </div>
                <div className="appliance-place">
                    {this.props.deviceData.data && this.props.deviceData.data.group}
                </div>
            </div>
        );
    };

    renderTotal = () => {
        if (!this.props.deviceData.energy) {
            return null;
        }

        const labelCostMode = getCostModeLabel(this.props.settings)

        return (
            <div className="total">
                <div className="total-sum">
                    <div className="total-sum__text">
                        Total energy
                    </div>
                    <div className="total-sum__amount">
                        {this.props.deviceData.energy.value} {labelCostMode}
                    </div>
                </div>
            </div>
        );

        // While no tariff
        /*
         <div className="total-tariff total-tariff--first">
         <div className="total-tariff__text">Tariff 1</div>
         <div className="total-tariff__amount">20.89 $</div>
         </div>
         <div className="total-tariff total-tariff--second">
         <div className="total-tariff__text">Tariff 1</div>
         <div className="total-tariff__amount">20.89 $</div>
         </div>
         */
    };

    renderMessages = () => {
        return null;
        // return (
        //     <div>
        //         <div className="appliance-message">
        //             <span className="appliance-message__order">3-rd</span>
        //             <span className="appliance-message__text">Consuming 32% of total house consumption</span>
        //         </div>
        //         <div className="appliance-status">
        //             <span className="appliance-status__icon">!</span>
        //             <span className="appliance-status__text">This month more than usual</span>
        //         </div>
        //     </div>
        // );
    };

    renderInfo = () => {
        if (isEmpty(this.props.deviceData.status)) {
            return null;
        }

        const { Icon } = this.props.deviceData.data.icon;
        const classNames = classnames({
            'appliance__icon': true,
            [this.props.deviceData.status.className]: !!this.props.deviceData.status.className,
            'is-rotate': !this.state.canResetRotate || this.props.deviceData.changeStatus && this.props.deviceData.changeStatus.isLoading
        });

        const { value, label } = !isNotActiveDeviceStatus(this.props.deviceData) && getControlChartValueAndLabel(this.props.deviceData.power && this.props.deviceData.power.value);

        return (
            <div className="appliance">
                <div className="appliance__status">
                    {this.props.deviceData.status.text}
                </div>
                <div className="appliance__icon-wrap" onClick={this.handleSetDeviceStatus}>
                    <div className={classNames}>
                        <Icon fill={this.props.deviceData.status.color}/>
                    </div>
                </div>
                <div className="appliance__power">
                    {value} {label}
                </div>
            </div>
        );
    };

    renderLoading = () => {
        if (this.props.isLoading) {
            return (
                <ProgressBar/>
            );
        }

        return null;
    };

    render() {
        if (isEmpty(this.props.deviceData.data)) {
            return null;
        }

        return (
            <div className="app-container">
                <div className="page">
                    {this.renderHeader()}
                    <div className="page__content">
                        {this.renderLoading()}
                        {this.renderBodyHeader()}
                        {this.renderInfo()}
                        {this.renderChartFilter()}
                        {this.renderChart()}
                        {this.renderTotal()}
                        {this.renderMessages()}
                    </div>
                </div>
            </div>
        );
    }
}

DevicePage.propTypes = {
    deviceData: React.PropTypes.object,
    costItems: PropTypes.array,
    date: PropTypes.object,
    handleDateChange: PropTypes.func,
    handleChartType: PropTypes.func,
    handleGetPrev: PropTypes.func,
    handleGetNext: PropTypes.func,
    handleSetDeviceStatus: PropTypes.func
};

export default DevicePage;



// WEBPACK FOOTER //
// ./app/components/pages/core/device/Device.page.jsx